import NodeReassignPanel from './nodeReassignPanel.container';

export default NodeReassignPanel;
